/* eslint-disable import/prefer-default-export */
const getUserObject = state => state.user.user;
const getUserPluggToTokens = state => state.user.user.pluggToTokens;
const getUserAppToken = state => state.user.user.token;

const getFilterVisible = state => state.filter.filter.visible;
const getFilterParams = state => state.filter.filter.params;

const getOrderObject = state => state.order.order;
const getActionList = state => state.action.action;

const currentPluggtocode = state => state.user.pluggtocode;

export default {
  getUserObject,
  getUserPluggToTokens,
  getUserAppToken,
  getFilterVisible,
  getFilterParams,
  getOrderObject,
  getActionList,
  currentPluggtocode
};



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/getters.js